module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kM5LK"))).then(() => parcelRequire('hEqeo'));